export const system = [
  /* ----------------------------↓↓↓↓↓↓↓------------------------------------ */
  /* ----------------------------↓↓↓↓↓↓↓------------------------------------ */
  /* ----------------------------↓↓↓↓↓↓↓------------------------------------ */
  /* -------------↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 后台管理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓------------------- */
  /* ----------------------------↓↓↓↓↓↓↓------------------------------------ */
  /* ----------------------------↓↓↓↓↓↓↓------------------------------------ */
  /* ----------------------------↓↓↓↓↓↓↓------------------------------------ */
  {
    // 管理员登录
    path: '/admin/login',
    name: 'adminLogin',
    component: _ => import('../components/admin/login.vue')
  },
  {
    path: '/admin/sysIndex',
    component: _ => import('../components/admin/sysIndex.vue'),
    children: [
      {path: '/', redirect: '/admin/welcome'},
      {
        path: '/admin/welcome',
        name: 'adminWelcome',
        component: _ => import('../components/admin/welcome.vue'),
      },
      {
        // 医生审核页
        path: '/admin/doctor/list',
        name: 'doctorList',
        component: () => import('../components/admin/doctor/list')
      }, {
        // 后台文章管理
        path: '/admin/page/list',
        name: 'pageList',
        component: () => import("../components/admin/page/page_list.vue")
      }, {
        // 后台文章详情
        path: '/admin/page/:type/details/:id',
        name: 'pageDetails',
        component: () => import("../components/admin/page/page_details.vue"),
        meta: {parentPath: '/admin/page'}
      }, {
        // 后台推荐设置
        path: '/admin/recommend/setting',
        name: 'recommendSetting',
        component: () => import("../components/admin/recommend/recommendSetting.vue")

      }, {
        path: "/admin/chatServer",
        name: 'chatServer',
        component: _ => import('../components/admin/chat/chatServer.vue')
      }, {
        path: '/admin/consultationManage',
        name: 'consultationManage',
        component: _ => import('../components/admin/consultation/consultationManage.vue')

      }, {
        path: '/admin/consultationDetails/:id',
        name: 'consultationDetails',
        component: _ => import('../components/admin/consultation/consultationDetails.vue'),
        meta: {parentPath: '/admin/consultationManage'}
      }, {
        //后台药物管理列表
        path: "/admin/drug/list",
        name: 'drugList',
        component: () => import ("../components/admin/drug/drugList.vue")
      }, {
        //后台药物编辑
        path: "/admin/drug/drugEdit",
        name: 'drugEdit',
        component: () => import ("../components/admin/drug/drugEdit.vue"),
        meta: {parentPath: '/admin/drug'}
      }, {
        //后台药物类别管理列表
        path: "/admin/drug/categoryList",
        name: "categoryList",
        component: () => import("../components/admin/drug/categoryList.vue"),
        meta: {parentPath: '/admin/drug'}
      }, {
        //后台药物类别编辑
        path: "/admin/drug/categoryEdit",
        name: "categoryEdit",
        component: () => import("../components/admin/drug/categoryEdit.vue"),
        meta: {parentPath: '/admin/drug'}
      }, {
        //后台适应症管理列表
        path: "/admin/indication/list",
        name: "indicationList",
        component: () => import("../components/admin/indication/indicationList.vue")
      }, {
        //后台适应症编辑添加
        path: "/admin/indication/edit",
        name: "indicationEdit",
        component: () => import("../components/admin/indication/indicationEdit.vue"),
        meta: {parentPath: '/admin/indication'}
      }, {
        //后台城市管理列表
        path: "/admin/city/list",
        name: "cityList",
        component: () => import("../components/admin/city/cityList.vue")
      }, {
        //后台医院/组织管理列表管理列表
        path: "/admin/city/item/list",
        name: "cityItemList",
        component: () => import("../components/admin/city/itemList.vue")
      }, {
        //后台管理
        path: "/admin/user/list",
        name: "userList",
        component: () => import("../components/admin/user/userList.vue")
      }, {
        path: '/admin/lectureManage',
        name: 'lectureManage',
        component: _ => import("../components/admin/lecture/lectureManage.vue")
      },
      {
        path: '/admin/lectureDetails/:id',
        name: 'lectureDetails',
        component: _ => import("../components/admin/lecture/lectureDetails.vue"),
        meta: {parentPath: '/admin/lectureManage'}
      }, {
        path: '/admin/lectureDetails_video/:id',
        name: 'lectureDetails_video',
        component: _ => import("../components/admin/lecture/lectureDetails_video.vue"),
        meta: {parentPath: '/admin/lectureManage'}
      }, {
        //后台事件管理
        path: "/admin/event/list",
        name: "eventList_admin",
        component: () => import("../components/admin/event/eventList.vue")
      }, {
        //文章历史
        path: "/admin/event/historyArticle/:id",
        name: "historyArticle",
        component: () => import("../components/admin/event/historyArticle.vue")
      }, {
        // 心理测试管理
        path: '/admin/exam/list',
        name: "adminExamList_admin",
        component: _ => import('../components/admin/exam/exam_manage.vue')
      }, {
        // 心理测试详情
        path: '/admin/exam/details/:id',
        name: 'adminExamDetails_admin',
        component: _ => import('../components/admin/exam/exam_details.vue'),
        meta: {parentPath: '/admin/exam'}
      }, {
        // 心理测试历史列表
        path: '/admin/exam/history/list',
        name: 'adminExamHistory',
        component: () => import('../components/admin/exam/examHistoryList.vue')
      }, {
        // 心理测试历史详情
        path: '/admin/exam/history/detail',
        name: 'adminExamHistoryDetail',
        component: () => import('../components/admin/exam/examHistoryDetail.vue')
      }, {
        //字典主表列表
        path: "/admin/dict/list",
        name: "catalogList_admin",
        component: () => import("../components/admin/dict/catalogList.vue")
      }, {
        //字典主表编辑/二级表列表
        path: "/admin/dict/edit",
        name: "catalogEdit",
        component: () => import("../components/admin/dict/catalogEdit.vue"),
        meta: {parentPath: '/admin/dict'}
      }, {
        //字典二级表编辑/三级表列表
        path: "/admin/dict/item/edit",
        name: "dictItemEdit",
        component: () => import("../components/admin/dict/itemEdit.vue"),
        meta: {parentPath: '/admin/dict'}
      }, {
        //字典三级表编辑
        path: "/admin/dict/item/sub/edit",
        name: "dictSubEdit",
        component: () => import("../components/admin/dict/subEdit.vue"),
        meta: {parentPath: '/admin/dict'}
      }, {
        //首页轮播图管理
        path: "/admin/index/banner",
        name: "adminBanner",
        component: () => import("../components/admin/indexBanner/indexBanner.vue")
      }, {
        path: "/admin/role/roleManage",
        name: 'roleManage',
        component: _ => import('../components/admin/auth/role_manage.vue')
      }, {
        // 权限管理
        path: '/admin/auth/authManage',
        name: 'authManage',
        component: _ => import('../components/admin/auth/auth_manage.vue')
      }, {
        // 预约管理
        path: '/admin/appoint/list',
        name: 'appointList',
        component: () => import('../components/admin/appoint/appointList.vue')
      }, {
        //模板消息管理-列表
        path: '/admin/message/template/list',
        name: 'templateList',
        component: () => import('../components/admin/message/templateList.vue')
      }, {
        //微信模板消息-列表
        path: '/admin/message/template/weChat/list',
        name: 'weChatTemplateList',
        component: () => import('../components/admin/message/weChatTemplateList.vue')
      }, {
        //管理员-医生详情
        path: '/admin/doctor/detail/:id',
        name: 'doctorDetailAdmin',
        component: () => import('../components/admin/doctor/doctorDetail.vue')
      }, {
        //管理员-用户详情
        path: '/admin/user/detail/:id',
        name: 'userDetailAdmin',
        component: () => import("../components/admin/user/userDetail.vue")
      }, {
        //管理员-预约详情
        path: '/admin/appoint/detail/:id',
        name: 'appointDetailAdmin',
        component: () => import("../components/admin/appoint/appointDetail.vue")
      }, {
        //管理员-新药管理
        path: '/admin/drug/fresh',
        name: 'freshDrugManage',
        component: _ => import('../components/admin/drug/freshDrug/freshDrugManage.vue')
      }, {
        // 管理员-医生申请
        path: '/admin/doctor/apply-list',
        name: 'DoctorApplyList',
        component: _ => import('../components/admin/doctor/apply_list.vue')
      }, {
        // 管理员-发送邮件
        path: '/admin/sendEmail/list',
        name: 'emailList',
        component: _ => import('../components/admin/email/emailList.vue')
      }, {
        // 管理员-发送邮件
        path: '/admin/sendEmail/edit',
        name: 'sendEmail',
        component: _ => import('../components/admin/email/sendEmail.vue')
      }, {
        // 管理员-反馈列表
        path: '/admin/feedback/list',
        name: 'feedbackList',
        component: _ => import('../components/admin/feedback/feedback_list.vue')
      }, {
        // 管理员=三级字典管理列表
        path: '/admin/dict/item/list',
        name: 'itemList',
        component: _ => import('../components/admin/dict/itemList')
      }, {
        // 管理员-系统文章管理
        path: '/admin/systemArticle/list',
        name: 'systemArticleList',
        component: _ => import('../components/admin/articleSystem/articleSystemList')
      }, {
        // 管理员-系统文章详情编辑
        path: '/admin/systemArticle/edit',
        name: 'systemArticleEdit',
        component: _ => import('../components/admin/articleSystem/articleSystemEdit')
      },{
        // 结账单
        path: '/admin/settlementBillList',
        name: 'settlementBillList',
        component: _ => import('../components/admin/financial/settlementBillList.vue')
      },{
        // 退款管理
        path: '/admin/refundBillList',
        name: 'refundBillList',
        component: _=> import('../components/admin/financial/refundBillList.vue')
      }, {
        // 企业管理
        path: '/admin/corpList',
        name: 'corpList',
        component: _ => import('../components/admin/corp/corpList.vue')
      }, {
        path: '/admin/welcomePage/doctorQuotationList',
        name: 'doctorQuotationList',
        component: _ => import('../components/admin/welcomePage/doctorQuotationList')
      }
    ]
  },
]
